export enum FormFields {
    PasswordValue = 'passwordValue',
    ConfirmPasswordValue = 'confirmPasswordValue',
}

export interface FormValues {
    password: string,
    confirmPassword: string,
}

export interface FormErrors {
    password?: string,
    confirmPassword?: string,
    validatedRequirements?: string[],
    hasPasswordErrors?: boolean,
    hasConfirmPasswordErrors?: boolean,
}

export const passwordRequirementTitleMappings: passwordRequirementTitleMapping = {
    validCharacters: 'use of approved characters',
    excludeUsername: 'cannot match 4 consecutive characters in your email',
    minLength: 'at least 8 characters',
    minLowerCase: 'at least 1 lowercase letter',
    minNumber: 'at least 1 number',
    minSymbol: 'at least 1 special character',
    minUpperCase: 'at least 1 uppercase letter',
    firstName: 'cannot use your first name',
    lastName: 'cannot use your last name',
};

export enum passwordRequirementTitle {
    validCharacters = 'validCharacters',
    excludeUsername = 'excludeUsername',
    minLength = 'minLength',
    minLowerCase = 'minLowerCase',
    minNumber = 'minNumber',
    minSymbol = 'minSymbol',
    minUpperCase = 'minUpperCase',
    firstName = 'firstName',
    lastName = 'lastName',
};

export const passwordPolicyNames = {
    activeDirectoryPolicy: 'Active Directory Policy',
    defaultPolicy: 'Default Policy',
};

export type passwordRequirementTitleMapping = {
    [key: string]: string;
};
export type passwordRequirements = {
    [key: string]: () => any;
};

export type ValidatedRequirements = string[];
export type InvalidRequirements = string[];
